import { createRouter as _createRouter, createWebHistory, createMemoryHistory } from 'vue-router'

import middlewarePipeline from "./middlewarePipeline.js";

export function createRouter() {



    const routes = [
        {
            path: '/',
            name: 'index',
            component: () => import('@/views/IndexPage.vue'),
            meta: {
                http_status: 200
            }
        },
        {
            path: '/personal',
            name: 'profile:personal',
            component: () => import('@/views/profile/ProfileWrap.vue'),
            meta: {
                http_status: 200
            }
        },
        {
            path: '/rewards',
            name: 'profile:rewards',
            component: () => import('@/views/profile/ProfileWrap.vue'),
            meta: {
                http_status: 200
            }
        },
        {
            path: '/catalog/:slug',
            name: 'catalog:category:page',
            component: () => import('@/views/pages/CategoryPage.vue'),
            meta: {
                http_status: 200
            }
        },
        {
            path: '/catalog/:slug_category/:slug_product',
            name: 'catalog:category:product:page',
            component: () => import('@/views/pages/ProductPage.vue'),
            meta: {
                http_status: 200
            }
        },
        {
            path: '/addresses',
            name: 'profile:addresses',
            component: () => import('@/views/profile/ProfileWrap.vue'),
            meta: {
                http_status: 200
            }
        },
        {
            path: '/addresses',
            name: 'profile:addresses',
            component: () => import('@/views/profile/ProfileWrap.vue'),
            meta: {
                http_status: 200
            }
        },
        {
            path: '/feedback',
            name: 'pages:feedback',
            component: () => import('@/views/pages/FeedbackPage.vue'),
            meta: {
                http_status: 200
            }
        },
        {
            path: '/vacancy',
            name: 'pages:vacancy',
            component: () => import('@/views/pages/VacancyPage.vue'),
            meta: {
                http_status: 200
            }
        },
        {
            path: '/promo',
            name: 'pages:promo',
            component: () => import('@/views/pages/PromoPage.vue'),
            meta: {
                http_status: 200
            }
        },
        {
            path: '/delivery',
            name: 'pages:delivery',
            component: () => import('@/views/pages/DeliveryPage.vue'),
            meta: {
                http_status: 200
            }
        },
        {
            path: '/news',
            name: 'news:list',
            component: () => import('@/views/news/index.vue'),
            meta: {
                http_status: 200
            }
        },
        {
            path: '/news/:identifier',
            name: 'news::detail:list',
            component: () => import('@/views/news/detail.vue'),
            meta: {
                http_status: 200
            }
        },
        {
            path: '/article/:id',
            name: 'pages:article',
            component: () => import('@/views/pages/ArticlePage.vue'),
            meta: {
                http_status: 200
            }
        },
        {
            path: '/articles/:slug',
            name: 'pages:article:slug',
            component: () => import('@/views/pages/ArticlePage.vue'),
            meta: {
                http_status: 200
            }
        },
        {
            path: '/order/history',
            name: 'profile:history',
            component: () => import('@/views/profile/ProfileWrap.vue'),
            meta: {
                http_status: 200
            }
        },
        {
            path: '/order',
            name: 'order:create',
            component: () => import('@/views/order/TheOrderCreate.vue'),
            meta: {
                http_status: 200
            }
        },
        {
            path: '/order/detail/:order_id',
            name: 'order:detail',
            component: () => import('@/views/order/TheOrderDetail.vue'),
            meta: {
                http_status: 200
            }
        },
        {
            path: '/product/:product_id',
            name: 'product:detail',
            component: () => import('@/views/pages/ProductPage.vue'),
            meta: {
                http_status: 200
            }
        },
        {
            path: "/error/403",
            name: '403',
            component: () => import('@/views/error/403.vue'),
            meta: {
                http_status: 403
            }
        },
        {
            path: "/error/404",
            name: '404',
            component: () => import('@/views/error/404.vue'),
            meta: {
                http_status: 404
            }
        },
        {
            path: '/:catchAll(.*)*',
            component: () => import('@/views/error/404.vue'),
            meta: {
                http_status: 404
            }
        },

    ]

    const baseUrl = import.meta.env.BASE_URL
    const history = import.meta.env.SSR ? createMemoryHistory(baseUrl) : createWebHistory(baseUrl)

    const router = _createRouter({
        history: history,
        routes,
        scrollBehavior(to, from, savedPosition) {
            if (to.hash) {
                return new Promise((resolve) => {
                    const hash = to.hash.slice(1);

                    let lastMainOffset = null;
                    let stableCount = 0;

                    const waitUntilStable = () => {
                        const el = document.getElementById(hash);
                        const main = document.querySelector('main');

                        if (!el || !main) {
                            return setTimeout(waitUntilStable, 50);
                        }

                        const currentOffset = main.getBoundingClientRect().top;

                        if (lastMainOffset !== null && Math.abs(currentOffset - lastMainOffset) < 1) {
                            stableCount++;
                        } else {
                            stableCount = 0;
                        }

                        lastMainOffset = currentOffset;

                        if (stableCount >= 3) {
                            resolve({
                                el,
                                behavior: 'smooth'
                            });
                        } else {
                            setTimeout(waitUntilStable, 50);
                        }
                    }

                    waitUntilStable();
                })
            } else {
                return { top: 0 };
            }
        }
    })

    router.beforeEach((to, from, next) => {

        const store = router.$store;
        if (to?.name && to.path != null) {
            store.state.canonical = to.path;
        }
        store.state.bottomMobileMenuIsShow = false;
        store.state.showLoginModal = false;
        if (to.name !== '404') {
            store.state.mainLoader = true;
        }
        if (to.name === 'order:create') {
            const shipping = store.state.shipping.shipping;

            if (!shipping) {
                if (!from.name || import.meta.env.SSR) {
                    return next({ name: 'index' });
                }

                store.commit('shipping/setShowModal', true);

                store.$toast.open({
                    message: 'Выберите способ получения заказа, чтобы перейти в корзину',
                    type: 'default',
                });

                store.state.mainLoader = false;
                return next(false);
            }
        }

        if (!to.meta?.middleware) {
            return next();
        }
        const { middleware } = to.meta;
        const context = {
            to, from, next, store, router
        };
        return middleware[0]({
            ...context,
            next: middlewarePipeline(context, middleware, 1),
        });
    });

    router.afterEach((to) => {

        const store = router.$store;
        setTimeout(() => {
            store.state.mainLoader = false;
        }, 500);
    });

    router.onError((error, to) => {
        if (typeof window === 'undefined' || !/dynamically imported module|Importing a module script failed|Unable to preload CSS/.test(error?.message ?? '')) {
            return;
        }
        try {
            const key = 'chunk-reload:' + to.fullPath;
            if (sessionStorage.getItem(key)) {
                return; // уже перезагружали — не зацикливаемся
            }
            sessionStorage.setItem(key, '1');
        } catch (e) {
            return;
        }
        window.location.assign(to.fullPath);
    });
    return router;
}


